export default "__VITE_ASSET__448c37d6__"